/**
 * Uploads a payment receipt before the cart form hands the customer to
 * Shopify checkout. Storage is intentionally delegated to the merchant's
 * configured app proxy/backend; a theme must not try to store image bytes in
 * a cart note or attribute.
 *
 * Expected endpoint contract:
 *   POST multipart/form-data with field `receipt`
 *   2xx JSON response: { "url": "https://..." }
 */
(function () {
  var proof = document.querySelector('[data-payment-proof]');
  if (!proof) return;

  var endpoint = (proof.getAttribute('data-upload-endpoint') || '').trim();
  var fileField = proof.querySelector('[data-payment-receipt-file]');
  var receiptUrlField = proof.querySelector('[data-payment-receipt-url]');
  var status = proof.querySelector('[data-payment-receipt-status]');
  var cartForm = proof.closest('form');
  if (!endpoint || !fileField || !receiptUrlField || !status || !cartForm) return;

  var copy = (window.theme && window.theme.cartCopy && window.theme.cartCopy.payment) || {};
  var maxBytes = 10 * 1024 * 1024;
  var bypassNextSubmit = false;

  function setStatus(message, type) {
    status.textContent = message || '';
    status.className = 'cart-payment__status' + (type ? ' cart-payment__status--' + type : '');
  }

  function isValidImage(file) {
    if (!file || file.size > maxBytes) return false;
    if (file.type && ['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type.toLowerCase()) !== -1) return true;
    return /\.(jpe?g|png|webp)$/i.test(file.name || '');
  }

  function rootUrl() {
    var root = (window.theme && window.theme.routesRoot) || '/';
    root = String(root);
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function uploadReceipt(file) {
    var body = new FormData();
    body.append('receipt', file, file.name);

    var uploadUrl = new URL(endpoint, document.baseURI).toString();
    return fetch(uploadUrl, {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error('receipt_upload_' + response.status);
        return data;
      });
    }).then(function (data) {
      var url = data && (data.url || data.file_url || data.fileUrl);
      if (!url || !/^https?:\/\//i.test(String(url))) throw new Error('receipt_upload_missing_url');
      return String(url);
    });
  }

  function saveReceiptToCart(url) {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_read_' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var attributes = Object.assign({}, cart.attributes || {});
        attributes['Payment receipt URL'] = url;
        return fetch(rootUrl() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_update_' + response.status);
        return response.json();
      });
  }

  fileField.addEventListener('change', function () {
    var file = fileField.files && fileField.files[0];
    receiptUrlField.value = '';
    if (!file) {
      setStatus('', '');
      return;
    }
    if (!isValidImage(file)) {
      fileField.value = '';
      setStatus(copy.receiptInvalid || 'Choose a JPG, PNG, or WebP image up to 10 MB.', 'error');
      return;
    }
    setStatus((copy.receiptSelected || 'Receipt selected: {{ name }}').replace('{{ name }}', file.name), '');
  });

  cartForm.addEventListener('submit', function (event) {
    if (bypassNextSubmit) {
      bypassNextSubmit = false;
      return;
    }
    if (!event.submitter || event.submitter.name !== 'checkout') return;

    var file = fileField.files && fileField.files[0];
    if (!file || receiptUrlField.value) return;

    event.preventDefault();
    if (!isValidImage(file)) {
      setStatus(copy.receiptInvalid || 'Choose a JPG, PNG, or WebP image up to 10 MB.', 'error');
      return;
    }

    var submitButton = event.submitter;
    submitButton.disabled = true;
    setStatus(copy.receiptUploading || 'Uploading receipt…', '');

    uploadReceipt(file)
      .then(function (url) {
        receiptUrlField.value = url;
        return saveReceiptToCart(url);
      })
      .then(function () {
        setStatus(copy.receiptUploaded || 'Receipt attached to this order.', 'success');
        submitButton.disabled = false;
        bypassNextSubmit = true;
        if (typeof cartForm.requestSubmit === 'function') {
          cartForm.requestSubmit(submitButton);
          return;
        }
        bypassNextSubmit = false;
        var checkoutField = document.createElement('input');
        checkoutField.type = 'hidden';
        checkoutField.name = 'checkout';
        checkoutField.value = '';
        cartForm.appendChild(checkoutField);
        HTMLFormElement.prototype.submit.call(cartForm);
      })
      .catch(function () {
        submitButton.disabled = false;
        setStatus(copy.receiptError || 'We could not upload that receipt. Please try another image or contact support.', 'error');
      });
  });
})();
